import React from 'react';
import './StudySetSelector.css';

function StudySetSelector({ studySets, onSelect }) {
  return (
    <div className="study-set-selector">
      <h2>Choose Your Study Set</h2>
      {studySets.length === 0 ? (
        <div className="no-sets">
          <p>No study sets available. Upload one to get started!</p>
        </div>
      ) : (
        <div className="study-sets-grid">
          {studySets.map((set) => (
            <div
              key={set.id}
              className="study-set-card"
              onClick={() => onSelect(set.id)}
            >
              <div className="card-header">
                <h3>{set.title}</h3>
                <span className={`difficulty-badge ${set.difficulty}`}>
                  {set.difficulty}
                </span>
              </div>
              <p className="description">{set.description}</p>
              <div className="card-footer">
                <span className="question-count">
                  📝 {set.questionCount} questions
                </span>
                {set.categories && set.categories.length > 0 && (
                  <div className="categories">
                    {set.categories.slice(0, 3).map((cat, idx) => (
                      <span key={idx} className="category-tag">
                        {cat}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default StudySetSelector;
